export enum AppLanguage {
    EnglishUS = "en_US",
    GermanDE = "de_DE",
}

export const DEFAULT_APP_LANGUAGE = AppLanguage.EnglishUS;

export const SUPPORTED_APP_LANGUAGES: AppLanguage[] = Object.values(AppLanguage);
